/**
 * Transactions State Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_trading_platform/src/master/application/Exporo/Trading/src/Datatypes/Enums/OfferStates.php
 */

const OfferStatesEnum = Object.assign({
  OPENED: 'Opened',
  CLOSED: 'Closed',
  CANCELLING: 'Cancelling',
  CANCELLED: 'Cancelled',
});

Object.freeze(OfferStatesEnum);

export default OfferStatesEnum;



// WEBPACK FOOTER //
// ./src/enum/trades/OfferStates.js